import { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { MobileCards, DataCard, EmptyCard } from "@/components/DataCards";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function AdminAudit() {
  const [data, setData] = useState({ items: [], total: 0 });
  const [page, setPage] = useState(1);
  const limit = 30;
  useEffect(() => { api.get(`/admin/audit?page=${page}&limit=${limit}`).then(({ data }) => setData(data)).catch(() => {}); }, [page]);

  return (
    <div className="space-y-6" data-testid="admin-audit">
      <h2 className="font-heading text-xl font-bold tracking-tight sm:text-2xl">Logs & Auditoria</h2>
      <MobileCards testid="audit-cards">
        {data.items.length === 0 && <EmptyCard>Sem registros.</EmptyCard>}
        {data.items.map((l, i) => (
          <DataCard
            key={i}
            testid={`audit-card-${i}`}
            title={l.action}
            subtitle={l.actor_email || "—"}
            rows={[
              { label: "IP", value: <span className="font-mono text-xs">{l.ip || "—"}</span> },
              { label: "Data", value: new Date(l.created_at).toLocaleString("pt-BR") },
              { label: "Dados", value: <span className="font-mono text-[11px]">{JSON.stringify(l.data)}</span>, full: true, wrap: true },
            ]}
          />
        ))}
      </MobileCards>

      <div className="hidden rounded-lg border border-border bg-card md:block">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Ação</TableHead><TableHead>Responsável</TableHead><TableHead>IP</TableHead><TableHead>Dados</TableHead><TableHead>Data</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {data.items.length === 0 && <TableRow><TableCell colSpan={5} className="py-10 text-center text-muted-foreground">Sem registros.</TableCell></TableRow>}
            {data.items.map((l, i) => (
              <TableRow key={i} data-testid={`audit-row-${i}`}>
                <TableCell className="font-medium">{l.action}</TableCell>
                <TableCell className="text-muted-foreground">{l.actor_email || "—"}</TableCell>
                <TableCell className="text-muted-foreground">{l.ip || "—"}</TableCell>
                <TableCell className="max-w-xs truncate text-xs text-muted-foreground">{JSON.stringify(l.data)}</TableCell>
                <TableCell className="text-muted-foreground">{new Date(l.created_at).toLocaleString("pt-BR")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {data.total > limit && (
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" disabled={page === 1} onClick={() => setPage((p) => p - 1)} data-testid="audit-prev">Anterior</Button>
          <Button variant="outline" size="sm" disabled={page * limit >= data.total} onClick={() => setPage((p) => p + 1)} data-testid="audit-next">Próxima</Button>
        </div>
      )}
    </div>
  );
}
